import { logError } from 'commons/logger';
import {
  ALGOLIA_PRODUCTS_INDEX,
  buildObjectDataEntry,
  doesHitMatchProduct,
  getHitQueryID,
  getInsightsUserToken,
  isAlgoliaInsightsReady,
  sumObjectDataValue,
} from './insightsObjectDataUtils';

const handleInsightsAddToCartAndConversion = ({
  hit = null,
  productId = null,
  price = 0,
  discount = 0,
  quantity = 1,
} = {}) => {
  if (!isAlgoliaInsightsReady()) {
    logError('Algolia Insights not initialized yet.');
    return;
  }

  const objectID = String(productId ?? '').trim();
  if (!objectID) {
    return;
  }

  const hitQueryID = getHitQueryID(hit);
  const matchesSearchHit =
    Boolean(hitQueryID) && doesHitMatchProduct(hit, objectID);

  const objectData = [
    buildObjectDataEntry({
      price,
      discount,
      quantity,
      queryID: matchesSearchHit ? hitQueryID : null,
    }),
  ];
  const value = sumObjectDataValue(objectData);
  const userToken = getInsightsUserToken();
  const hasSearchAttribution = Boolean(objectData[0].queryID);

  const payload = {
    eventName: 'Product Added to Cart',
    userToken,
    index: ALGOLIA_PRODUCTS_INDEX,
    objectIDs: [objectID],
    objectData,
    value,
    currency: 'USD',
  };

  if (hasSearchAttribution) {
    window.aa('addedToCartObjectIDsAfterSearch', {
      ...payload,
      queryID: hitQueryID,
    });
    window.aa('convertedObjectIDsAfterSearch', {
      eventName: 'User Converted After Search',
      userToken,
      index: ALGOLIA_PRODUCTS_INDEX,
      objectIDs: [objectID],
      queryID: hitQueryID,
    });
  } else {
    window.aa('addedToCartObjectIDs', payload);
  }
};

export default handleInsightsAddToCartAndConversion;
